import { useIntl } from 'react-intl';
import { showNotification } from '../components/molecules/Notifications';
import { additionalConfig } from '../components/molecules/PaymentOptions';
import { getLinksForTranslation } from '../components/atoms/Link';
import { Notification } from './checkoutState';
import camelCase from 'lodash.camelcase';
import { getCurrencyConfig } from '../components/atoms/FormattedCurrency';

const useGenericNotifications = () => {
  const { formatMessage, formatDisplayName, formatNumber } = useIntl();

  const getTranslatedPaymentMethod = (paymentOptionKey: string) => {
    const i18nKey = additionalConfig[paymentOptionKey]?.i18nKey ?? camelCase(paymentOptionKey);
    return formatMessage({ id: `payment.paymentMethod.options.${i18nKey}` });
  };

  const formatReplacements = (replacements: Record<string, any>) => {
    const { paymentOptionKey, paymentOptionKeys, date, orderValue, countryCode, countryCodes } = replacements;
    return {
      ...replacements,
      ...(paymentOptionKey && {
        paymentMethodName: getTranslatedPaymentMethod(paymentOptionKey),
      }),
      ...(paymentOptionKeys && {
        paymentMethodNames: paymentOptionKeys
          .replaceAll(' ', '')
          .split(',')
          .map((item: string) => getTranslatedPaymentMethod(item))
          .join(', '),
      }),
      ...(date && {
        date: new Date(date),
      }),
      ...(orderValue && {
        orderValue: formatNumber(orderValue / 100, { ...getCurrencyConfig() }),
      }),
      ...(countryCode && {
        countryName: formatDisplayName(countryCode, { type: 'region' }),
      }),
      ...(countryCodes && {
        countryNames: countryCodes
          .replaceAll(' ', '')
          .split(',')
          .map((code: string) => formatDisplayName(code, { type: 'region' }))
          .join(', '),
      }),
    };
  };

  const triggerGenericNotifications = (notifications: Notification[]) => {
    notifications.forEach(({ type, text, textTranslationKey, replacements = {} }) => {
      const intlReplacements = formatReplacements(replacements);
      setTimeout(
        () =>
          showNotification({
            level: type,
            text:
              text ?? formatMessage({ id: textTranslationKey }, { ...getLinksForTranslation(), ...intlReplacements }),
          }),
        0
      );
    });
  };

  return { triggerGenericNotifications };
};

export default useGenericNotifications;
